import { render, staticRenderFns } from "./InventoryVisits.vue?vue&type=template&id=954fa652"
import script from "./InventoryVisits.vue?vue&type=script&lang=js"
export * from "./InventoryVisits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports